import type { FC } from "react";
import React, { useState } from "react";
import {
  Box, Card, Container, Typography,
} from "@mui/material";
import { Navigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import { isAuthenticated, setAuthToken } from "../../services/request";
import AuthField from "./AuthField";
import SelectProductCompanyField from "./SelectProductCompanyField";
import type { setAuthDataSaga } from "../../actions/auth";

type Props = {
  location: any,
  history: any,
  onLogin: typeof setAuthDataSaga,
}

const useStyles = makeStyles((theme) => ({
  container: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  title: {
    color: theme.palette.primary.main,
    fontWeight: 700,
    paddingBottom: theme.spacing(2),
  },
}));

const Login: FC<Props> = ({ location, history, onLogin }: Props) => {
  const classes = useStyles();
  const [loginData, setLoginData] = useState<{token: string, expires: number} | void>();

  if (isAuthenticated()) {
    const { from } = location.state || { from: { pathname: "/" } };
    return <Navigate to={from} />;
  }

  const handleSubmit = (companies: string[]) => {
    if (loginData) {
      const { from } = location.state || { from: { pathname: "/" } };
      onLogin({
        history,
        companies,
        redirect: from.pathname,
        expires: new Date(loginData.expires * 1000),
      });
    }
  };

  return (
    <Container component="main" maxWidth="xs" className={classes.container}>
      <Card>
        <Box display="flex" flexDirection="column" alignItems="center" p={2}>
          <Typography variant="h2" className={classes.title}>
            Sign In
          </Typography>
          { !loginData ? (
            <AuthField onNext={(data: {expires: number, token: string}) => {
              setAuthToken(data.token, new Date(data.expires * 1000));
              setLoginData(data);
            }}
            />
          ) : (
            <SelectProductCompanyField onNext={handleSubmit} />
          )}
        </Box>
      </Card>
    </Container>
  );
};

export default Login;
